import { Facade } from '@niknevis/vue-modules'
import { Str as StrService } from '../string'

export class Str extends Facade<StrService>() {
  static getFacadeAccessor() {
    return StrService
  }
}
